(() => {
  if (customElements.get('cookie-consent')) return;
  class CookieConsent extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.hidden = true;
      const pageContent = document.getElementById('MainContent');
      const roomHero = pageContent?.querySelector('.gdr-home-hero');
      if (roomHero) roomHero.after(this);
      else if (pageContent && this.nextElementSibling !== pageContent) pageContent.before(this);
      this.buttons = [...this.querySelectorAll('[data-gd-cookie-choice]')];
      this.error = this.querySelector('[data-gd-cookie-error]');
      this.preferencesSlot = document.querySelector('[data-gd-cookie-preferences-slot]');
      this.reopen = this.preferencesSlot?.querySelector('[data-gd-cookie-preferences]');
      this.status = this.preferencesSlot?.querySelector('[data-gd-cookie-status]');
      this.buttons.forEach(button => button.addEventListener('click', () => this.save(button.dataset.gdCookieChoice === 'accept')));
      this.reopen?.addEventListener('click', () => {
        this.userOpened = true;
        this.previousFocus = document.activeElement;
        this.hidden = false;
        this.buttons[0]?.focus();
      });
      this.onConsent = () => this.synchronize();
      document.addEventListener('visitorConsentCollected', this.onConsent);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.hasChoice()) {
          this.userOpened = false;
          this.hidden = true;
          this.reopen?.focus({ preventScroll: true });
        }
      });
      window.GDPrivacy?.ready().then(privacy => {
        if (!privacy || !this.isConnected) return;
        this.privacy = privacy;
        const footer = document.querySelector('.wrapper-footer');
        if (footer && this.preferencesSlot) footer.appendChild(this.preferencesSlot);
        if (this.preferencesSlot) this.preferencesSlot.hidden = false;
        this.synchronize();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('visitorConsentCollected', this.onConsent);
    }

    hasChoice() {
      try {
        const consent = this.privacy?.currentVisitorConsent();
        return !!consent && ['analytics', 'marketing', 'preferences'].every(purpose => consent[purpose] === 'yes' || consent[purpose] === 'no');
      } catch (_) { return false; }
    }

    synchronize() {
      if (!this.privacy || this.saving) return;
      const nativeBanner = document.querySelector('#shopify-pc__banner, #shopify-pc__prefs');
      if (nativeBanner) {
        this.hidden = true;
        if (this.preferencesSlot) this.preferencesSlot.hidden = true;
        return;
      }
      try {
        this.hidden = !this.userOpened && (this.hasChoice() || !this.privacy.shouldShowBanner());
      } catch (_) { this.hidden = true; }
    }

    save(accepted) {
      if (!this.privacy || this.saving) return;
      this.saving = true;
      this.error.hidden = true;
      this.buttons.forEach(button => { button.disabled = true; });
      let completed = false;
      const finish = error => {
        if (completed) return;
        completed = true;
        window.clearTimeout(timeout);
        this.saving = false;
        this.buttons.forEach(button => { button.disabled = false; });
        if (error || !this.hasChoice()) {
          this.error.hidden = false;
          return;
        }
        const restoreFocus = this.contains(document.activeElement);
        this.userOpened = false;
        this.hidden = true;
        if (this.status) this.status.textContent = this.status.dataset.savedText;
        if (restoreFocus) {
          const target = this.previousFocus?.isConnected ? this.previousFocus : this.reopen;
          target?.focus({ preventScroll: true });
        }
      };
      const timeout = window.setTimeout(() => finish(true), 10000);
      try {
        this.privacy.setTrackingConsent({ analytics: accepted, marketing: accepted, preferences: accepted }, finish);
      } catch (_) { finish(true); }
    }
  }
  customElements.define('cookie-consent', CookieConsent);
})();


// Keep Shopify's native choices in normal page flow when its banner is enabled.
(() => {
  function placeNativeBanner() {
    const banner = document.getElementById('shopify-pc__banner');
    const main = document.getElementById('MainContent');
    if (!banner || !main) return;
    const hero = main.querySelector('.gdr-home-hero');
    if (hero && hero.nextElementSibling !== banner) hero.after(banner);
    else if (!hero && banner.nextElementSibling !== main) main.before(banner);
  }
  function start() {
    placeNativeBanner();
    new MutationObserver(placeNativeBanner).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
